import { tryCatch } from '@wix/funnel-utils'

import type { interactions } from '../../../fedops.json'
import type { monitoring } from '../appMonitoring'
import { reportError } from '../reportError'

type OperationName = keyof typeof interactions

type InteractionMonitor = Pick<typeof monitoring, 'interactionStarted' | 'interactionEnded'>

export default (monitoring: InteractionMonitor) => {
  return async <TResult>(operation: () => Promise<TResult>, operationName: OperationName) => {
    monitoring.interactionStarted(operationName)
    const [error, result] = await tryCatch(operation)
    if (error) {
      reportError(error, { operationName })
      throw error
    }
    monitoring.interactionEnded(operationName)
    return result
  }
}
